import { render, staticRenderFns } from "./UserWidget.vue?vue&type=template&id=60570ec2&scoped=true&"
import script from "./UserWidget.vue?vue&type=script&lang=js&"
export * from "./UserWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserWidget.vue?vue&type=style&index=0&id=60570ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60570ec2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60570ec2')) {
      api.createRecord('60570ec2', component.options)
    } else {
      api.reload('60570ec2', component.options)
    }
    module.hot.accept("./UserWidget.vue?vue&type=template&id=60570ec2&scoped=true&", function () {
      api.rerender('60570ec2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserWidget.vue"
export default component.exports